module.exports = __webpack_public_path__ + "static/media/smartstream.3b255f2c.jpeg";